import { trpc } from 'root/src/client/v2/trpc/trpc';
import { DropSerializer } from 'root/src/shared/drops/drops.constants';
import { DROPS_STALE_TIME_MS, DROPS_TAB_SECTION_MAP, DropsTabStatus, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
// Total drops per status tab (Live / Coming soon / Private) for the tab count badges. Independent of
// the All / Recommended / Eligible filter chips and the search (those narrow the grid, not the tab
// total), mirroring how the other redesign list pages count their tabs. Each section is its own
// getDrops query (shared React Query cache, 10s stale, so it overlaps the active tab's list query);
// demo drops are excluded so the count matches what the grid shows.
export const useDropsTabCounts = () => {
    const live = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[DropsTabStatus.Live],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: undefined,
    }, { staleTime: DROPS_STALE_TIME_MS });
    const soon = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[DropsTabStatus.Soon],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: undefined,
    }, { staleTime: DROPS_STALE_TIME_MS });
    const priv = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[DropsTabStatus.Private],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: undefined,
    }, { staleTime: DROPS_STALE_TIME_MS });
    const toCount = (data) => (data ? data.items.filter(item => !item.isDemo).length : undefined);
    return {
        [DropsTabStatus.Live]: toCount(live.data),
        [DropsTabStatus.Soon]: toCount(soon.data),
        [DropsTabStatus.Private]: toCount(priv.data),
    };
};
